module.exports = __webpack_public_path__ + "58dd1bf0d5ebb078b6d74c86e24a81b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/ezload.png
// module id = 1535
// module chunks = 1 2